export const BATCH_EVENTS = {
  START: '.batch.started',
  FINISH: '.batch.finished',
  PROGRESSED: '.batch.progressed'
};
